import CategoryManager
  from '../components/CategoryManager';

export default function PersonalOrganizationPage({
  currentUser
}) {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Personal Organization</h1>

      <CategoryManager
        title="Focus Areas"
        categoryType="focus_area"
        userId={currentUser?.id}
      />

      <CategoryManager
        title="Contexts"
        categoryType="context"
        userId={currentUser?.id}
      />

      <CategoryManager
        title="Locations"
        categoryType="locations"
        userId={currentUser?.id}
      />
    </div>
  );
}